module.exports = __webpack_public_path__ + "static/media/bg_page65_opt.16ed6317.png";